import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContenedorBoton } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import SelectArticulo from '../inventario/selectArticulo';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import { cargar_Articulos, inicializarArticulos, cargar_StocksArticulo, cargar_ReservasArticulo, inicializarArticulo } from '../../actions/inventario/act_inven01';
import styled from 'styled-components';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';

const TitleArticulo = styled.h6`
    color: red;
    font-weight: bold;
`;

const ContenedorModal = styled.div`  
  padding: 20px;
  height: 450px;
  width: 700px;
`;

class FormInven09  extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            articulo: null,
            descripcionArt: '',
            codOrigArt: '',
            codFabricaArt: '',
            vehiculosAplica: '',
            articulo_sel: '',
            isVisibleModalFoto: false,
            ubicacionBogPrinc: '',

            columDefGridArticulos:[
                {   header: "No.",
                    field: "Nro",
                    width: 35,
                    type: "string",
                    suppressFilter: true                    
                },
                {   header: "Articulo",
                    field: "Articulo",
                    width: 70,
                    type: "string"
                },                                   
                {   header: "Descripción",
                    field: "Descripcion",
                    width: 265,
                    type: "string"
                },
                {   header: "Marca",
                    field: "Marca",
                    width: 140,
                    type: "string"
                },
                {   header: "Cod. Parte Orig.",
                    field: "CodOriginal",
                    width: 130,
                    type: "string"
                },
                {   header: "Cod. Fábrica",
                    field: "CodFabrica",
                    width: 120,
                    type: "string"
                },
                {   header: "Procedencia",
                    field: "Origen",
                    width: 130,
                    type: "string"
                },
                {   header: "Vehículos Aplic.",
                    field: "VehiculosAplic",
                    width: 250,
                    type: "string"
                },
                {   header: "Precio May.",
                    field: "PrecioMayorista",
                    width: 65,
                    type: "num_decimal",
                    filter: "number"
                },
                {   header: "Estado",
                    field: "Status",
                    width: 65,
                    type: "string"                    
                }
            ],
            columDefGridStock: [
                {   header: "Bodega",
                    field: "Bodega",
                    width: 172,
                    type: "string"
                },
                {   header: "Stock",
                    field: "Stock",
                    width: 75,
                    type: "num_entero"
                },
                {   header: "Reserva",
                    field: "Reserva",
                    width: 75,
                    type: "num_entero"
                },
                {   header: "Disponible",
                    field: "Disponible",
                    width: 80,
                    type: "num_entero"
                },
            ],            
            columDefGridReservas: [
                {   header: "Bodega",
                    field: "Bodega",
                    width: 140,
                    type: "string"
                },                
                {   header: "Cant.",
                    field: "Cantidad",
                    width: 60,
                    type: "num_entero"
                },
                {   header: "Pedido M.",
                    field: "PedidoMovil",
                    width: 75,
                    type: "string"
                },
                {   header: "Proforma",
                    field: "Proforma",
                    width: 72,
                    type: "string"
                },
                {   header: "Cliente",
                    field: "Cliente",
                    width: 300,
                    type: "string"
                },                
                {   header: "Cod. Reserva",
                    field: "Reserva",
                    width: 90,
                    type: "num_entero"
                },
                {   header: "Fecha Reserva",
                    field: "FechaReserva",
                    width: 100,
                    type: "string"
                },
            ]
        };
        
        this.gridArticulosOptions = {
            enableColResize: true,
            enableFilter: true,
            enableSorting: true,
            rowSelection: 'single',
            onSelectionChanged: ()=>{ this.onSelectionArticuloChanged(); }
        }

        this.gridStockOptions = {
            enableColResize: true
        }

        this.gridReservasOptions = {
            enableColResize: true
        }

        this.limpiar = this.limpiar.bind(this);        
        this.handleInputChange = this.handleInputChange.bind(this);
        this.cargarArticulos = this.cargarArticulos.bind(this);
        this.onGridArticulosReady = this.onGridArticulosReady.bind(this);
        this.onGridStockReady = this.onGridStockReady.bind(this);
        this.onGridReservasReady = this.onGridReservasReady.bind(this);
    }

    onGridArticulosReady(params){
        this.gridApiArticulos = params.api;
        this.columnApiArticulos = params.columnApi;
    }

    onGridStockReady(params){
        this.gridApiStock = params.api;
        this.columnApiStock = params.columnApi;
    }

    onGridReservasReady(params){
        this.gridApiReservas = params.api;
        this.columnApiReservas = params.columnApi;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0209');
        this.props.inicializarArticulos();
        this.props.inicializarArticulo();
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0209');
    }

    onSelectionArticuloChanged(){
        let articulosSeleccionados = this.gridApiArticulos.getSelectedRows();
        if (articulosSeleccionados.length===1){            
            this.setState({ articulo_sel: `${articulosSeleccionados[0].Articulo} - ${articulosSeleccionados[0].Descripcion}`,
                            ubicacionBogPrinc: articulosSeleccionados[0].Ubicacion});
            this.props.cargar_StocksArticulo(articulosSeleccionados[0].Articulo);
            this.props.cargar_ReservasArticulo(articulosSeleccionados[0].Articulo);
        }else{
            this.setState({articulo_sel: ''});
        }
    }
    
    limpiar(){
        this.setState({
            articulo: null,
            descripcionArt: '',
            codOrigArt: '',
            codFabricaArt: '',
            vehiculosAplica: '',
            articulo_sel: '',
            isVisibleModalFoto: false,
            ubicacionBogPrinc: ''
        });        

        this.props.inicializarArticulos();
        this.props.inicializarArticulo();
    }        

    cargarArticulos(){        
        let codArticulo = this.state.articulo;
        let descripArticulo = this.state.descripcionArt.trim();
        let codOriginalArticulo = this.state.codOrigArt.trim();
        let codFabricaArticulo = this.state.codFabricaArt.trim();
        let descripVehiculosAplica = this.state.vehiculosAplica.trim();

        if (codArticulo!==null && (
            descripArticulo !== '' || codOriginalArticulo !== '' || codFabricaArticulo !== '' || descripVehiculosAplica !== '')){
                alert('Ud. ha especificado un Código de Artículo y otros filtros de búsqueda. No es posible realizar esta consulta.');
                return;
            }
        this.props.cargar_Articulos(codArticulo, descripArticulo, codOriginalArticulo, codFabricaArticulo, descripVehiculosAplica);
    }

    render(){
        return (
            <div>
                <ContenedorForm porc_ancho={96}>
                    <HeaderForm>
                        <TituloForm>Catálogo de Artículos</TituloForm>
                    </HeaderForm>
                    <CuerpoForm>
                        <Row margen_arriba={5}>
                            <ContainerCol className='col-sm-3'>
                                <LabelForm>Artículo:</LabelForm>
                                <SelectArticulo tipoArticulos='P' value={this.state.articulo}
                                    func_onChange={(value)=>{if(Array.isArray(value)){value=null;} 
                                    this.setState({articulo: value===null?null:value.value})}}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Descripción:</LabelForm>
                                <InputText autoComplete='off' name='descripcionArt' 
                                    value={this.state.descripcionArt} type='text' className='form-control input-sm' 
                                    placeholder='Descripción' onChange={this.handleInputChange}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Cód. Parte Original:</LabelForm>
                                <InputText autoComplete='off' name='codOrigArt'
                                    value={this.state.codOrigArt} type='text' className='form-control input-sm' 
                                    placeholder='Cód. Parte Original' onChange={this.handleInputChange}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Cód. Fábrica:</LabelForm>
                                <InputText autoComplete='off' name='codFabricaArt'
                                    value={this.state.codFabricaArt} type='text' className='form-control input-sm' 
                                    placeholder='Cód. Fábrica' onChange={this.handleInputChange}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-2'>
                                <LabelForm>Vehículos Aplica:</LabelForm>
                                <InputText autoComplete='off' name='vehiculosAplica'
                                    value={this.state.vehiculosAplica} type='text' className='form-control input-sm' 
                                    placeholder='Marca/modelo de vehículo' onChange={this.handleInputChange}/>
                            </ContainerCol>
                            <ContainerCol className='col-sm-1'>
                                <ContenedorBoton margen_arriba={20}>
                                    <Tooltip placement="right" overlay='Buscar artículos'>
                                        <button type='button' className='btn btn-success btn-sm' onClick={this.cargarArticulos}><i className='fa fa-search'></i> Buscar</button>
                                    </Tooltip>
                                </ContenedorBoton>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <AgGridRender altura='250px' data={this.props.articulos} columnas={this.state.columDefGridArticulos} gridOptions={this.gridArticulosOptions}
                                    onGridReady={this.onGridArticulosReady}/>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-12'>                            
                                <Row>                              
                                    <ContainerCol className='col-sm-8'>
                                        <TitleArticulo>{this.state.articulo_sel}</TitleArticulo>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-3' isInvisible={this.state.articulo_sel===''}>
                                        <LabelForm>Ubicación en Bod. Principal: {this.state.ubicacionBogPrinc}</LabelForm>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-1' isInvisible={this.state.articulo_sel===''}>
                                        <button type='button' className='btn btn-link btn-xs' onClick={()=>{this.setState({isVisibleModalFoto: true})}}><i className='fa fa-picture-o'></i> Ver Foto</button>
                                    </ContainerCol>
                                </Row>
                                <Row>
                                    <ContainerCol className='col-sm-4'>
                                        <AgGridRender altura='150px' data={this.props.stocksArticulo?this.props.stocksArticulo:[]} columnas={this.state.columDefGridStock} gridOptions={this.gridStockOptions}
                                            onGridReady={this.onGridStockReady}/>
                                    </ContainerCol>
                                    <ContainerCol className='col-sm-8'>
                                        <AgGridRender altura='150px' data={this.props.reservasArticulo?this.props.reservasArticulo:[]} columnas={this.state.columDefGridReservas} gridOptions={this.gridReservasOptions}
                                            onGridReady={this.onGridReservasReady}/>
                                    </ContainerCol>                                
                                </Row>
                            </ContainerCol>
                        </Row>
                        <Row>
                            <ContainerCol className='col-sm-12'>
                                <div className='btn-group pull-right'>
                                    <button type='button' className='btn btn-sm'  onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'></i> Limpiar</button>
                                </div>
                            </ContainerCol>
                        </Row>
                    </CuerpoForm>
                </ContenedorForm>
                <ModalResponsive open={this.state.isVisibleModalFoto} onClose={()=>{this.setState({isVisibleModalFoto:false})}}>
                    <ContenedorModal>
                        <img    src={  (this.state.articulo_sel!==''?`/img/articulos/${this.state.articulo_sel.substr(0, 5)}.jpg`:'') }
                                alt={ (this.state.articulo_sel!==''?`${this.state.articulo_sel.substr(0, 5)}`:'') }
                                width={'100%'} height={'90%'}/>
                    </ContenedorModal>
                </ModalResponsive>
            </div>
        )
    }
}

const mapStateToProps = ((state) => {
    return {    articulos: state.inventario.articulos,
                stocksArticulo: state.inventario.articulo_Sel.stocks,
                reservasArticulo: state.inventario.articulo_Sel.reservas
            }
});
  
const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, 
                                generar_LogAuditoriaSalidaForm,
                                cargar_Articulos, inicializarArticulos,
                                cargar_StocksArticulo, cargar_ReservasArticulo,
                                inicializarArticulo
                            }, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormInven09);